<template>
  <b-card-code title="Lista de Relatorios">
    <b-row>
      <b-col
        md="6"
        xl="6"
        class="mb-1"
      >
        <b-form-group
          label="Nome do Relatorio:"
        >
          <b-form-input
            id="descricaoRelatorio"
            placeholder=""
            v-model="FiltroTela.descricaoRelatorio"
          />
        </b-form-group>
      </b-col>
    <b-col
        md="6"
        xl="4"
        class="mb-1"
    >
    <br>
    <div class="DivBotaoLadoLado" >
     <b-button  variant="primary"
      type="button" @click="Consultar"><span>BUSCAR</span></b-button>
    </div>
    </b-col>
    </b-row>
    <b-table
      striped
      hover
      responsive
      class="position-relative"
      :per-page="perPage"
      :current-page="currentPage"
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :filter="filter"
      :filter-included-fields="filterOn"
      table-class = "font-size11"
      thead-class = "font-size11"
      thead-tr-class = "font-size11"
    >
    <template #cell(rota)="row">
        <b-col
        md="6"
        xl="1"
        class="mb-1"
        >
        <b-button
          @click="RedirecionaDetalhe(row.item.rota, row.item.descricaoRelatorio)" class="mr-1">
          <feather-icon
            :icon="'LogInIcon'"
            size="15"
          />
        </b-button>
        </b-col>
      </template>
    </b-table>
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

      <!-- page length -->
      <b-form-group
        label="Registros por Pagina"
        label-cols="8"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
</b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import apiPortalSky from '@/services/apiPortalSky'
import AlertaMsg from '@/customPortal/AlertaMsg.vue'

import FiltrosPortal from '@/customPortal/FiltrosPortal.vue'
// import UtilVUE from '@/customPortal/UtilVUE.vue'
import Spinner from '@/components/Spinner.vue'

import {
  BRow, BFormGroup,
  BTable, BFormSelect, BPagination,
  BCardBody, BFormInput, BCol, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BFormInput,
    BCardCode,
    BFormGroup,
    BRow,
    BTable,
    BFormSelect,
    BPagination,
    BCardBody,
    BCol,
    BButton,
  },
  data() {
    return {
      FiltroTela: {
        TitloTela: 'relatorios',
        Selecionado: false,
        descricaoRelatorio: '',
        FiltroComplementar: [],
      },
      perPage: 10,
      pageOptions: [3, 5, 10, 50],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        { key: 'rota', label: 'ACESSAR' },
        { key: 'descricaoRelatorio', label: 'Nome', sortable: true },
      ],
      /* eslint-disable global-require */
      items: [
      ],
    }
  },
  mounted() {
    // Seta q quantidade de Linhas no Grid
    this.totalRows = this.items.length
    // Consulta Dados para Filtro na Tela
    this.DescarregarFiltroTela()
  },
  methods: {
    async Consultar() {
      Spinner.StarLoad()
      let notification = ''
      const usuario = this.$session.get('usuario')
      const URLpost = `/Report/ConsultaReport?CODUSU=${usuario.codusu}&DESCRICAORELATORIO=${this.FiltroTela.descricaoRelatorio}`
      this.CarregaFiltroTela()
      await apiPortalSky.post(URLpost, '').then(response => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            this.items = response.data
            this.totalRows = this.items.length
          } else {
            notification = AlertaMsg.FormataMsgFiltroSemRetorno()
            AlertaMsg.FormataMsg(notification)
          }
        }
      }).catch(error => {
        notification = AlertaMsg.FormataMsgAPIError(error)
        AlertaMsg.FormataMsg(notification)
      })

      if(notification === '') {
       Spinner.EndLoad()
      }
    },
    RedirecionaDetalhe(RelRota, RelName) {
      const $rota = `../${RelRota}`
      this.$router.push($rota)
    },
    CarregaFiltroTela() {
      const usuario = this.$session.get('usuario')
      usuario.filtrosTela = FiltrosPortal.AdcionarFiltro(usuario, this.FiltroTela)
      this.$session.set('usuario', usuario)
    },
    DescarregarFiltroTela() {
      const usuario = this.$session.get('usuario')
      const Filtrado = FiltrosPortal.RetornaFiltro(usuario, this.FiltroTela.TitloTela)
      if (Filtrado.Selecionado) {
        // Realiza Validacao de Campo da Tela para Executar Realmente o Filtro
        if (Filtrado.descricaoRelatorio !== '') {
          this.FiltroTela = Filtrado// Carrega o Filtro
          
          // Descarrega Filtro Complementar
          //this.FiltroTela.FiltroComplementar.forEach(ftComplementar => {
          //  switch (ftComplementar.parametro) {
          //    case "":
          //      break
          //     
          //  }

          this.Consultar() // Executa o Filtro
        }
      }
    },
  },
  computed: {
  },
}
</script>
